module.exports = __webpack_public_path__ + "static/media/beach.168dbc7a.jpg";